import * as React from 'react';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import BuyMeACoffeeButton from '../AuthUI/BuyMeACoffeeButton';





  const CustomStyledCard = styled(Card)(({ theme, open }) => ({
    opacity: open?1:0,
    transition: theme.transitions.create(['opacity'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  }));

  function CardAlert({ open }) {
    return (
      
      <CustomStyledCard  open={open} variant="outlined" sx={{ m: 1.5, p: 1.5, textAlign: 'center', overflow: 'visible' }}>
        <CardContent>
          <AutoAwesomeRoundedIcon fontSize="large" />
          {/* <Typography gutterBottom sx={{ fontWeight: 600 }}>
            Plan about to expire
          </Typography> */}
          {/* <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
            Enjoy 10% off when renewing your plan today.
          </Typography> */}
          <BuyMeACoffeeButton />
          {/* <Button variant="contained" size="small" fullWidth>
            Get the discount
          </Button> */}
        </CardContent>
      </CustomStyledCard >
    );

  }
  export default CardAlert;
